<!--
* @description  参数1
* @fileName  confirmOrder
* @author userName
* @date 2024-01-17 10:53:58
!-->
<template>
  <div id="confirmOrder" class="confirmOrder">
    <div class="confirmOrder-container">
      <div class="confirmOrder-header flex flex-column-center flex-row-between margin-top_32">
        <div>
          <div class="confirmOrder-header-title">填写订单信息</div>
          <div class="confirmOrder-header-text">
            填写下面所需的信息，以便我们的提供商可以处理您的货件。
          </div>
        </div>
        <button type="button" class="close-btn" @click="close">
          <span>关闭</span><i class="margin-left_8 el-icon-close" />
        </button>
      </div>
      <div class="confirmOrder-info margin-top_24">
        <div class="confirmOrder-info-top flex flex-row-between flex-column-center">
          <div class="flex flex-column-center">
            <div class="confirmOrder-info-top__text1">订单号：</div>
            <div class="confirmOrder-info-top__text2">{{ data.orderNo }}</div>
            <div class="confirmOrder-info-top__text1 margin-left_24">
              参考号：
            </div>
            <el-input
              v-model="data.refNo"
              type="text"
              style="width: 228px"
              placeholder="输入您的参考号"
              @blur="saveRefNo()"
            />
          </div>
          <div class="flex flex-column-center">
            <button
              type="button"
              class="confirmOrder-info-top__btn1 flex flex-column-center"
              @click="clickChat"
            >
              <img
                src="@/assets/img/client/check/ask.png"
                width="16px"
                height="16px"
                alt="con"
              ><span class="margin-left_2">联系我们</span>
            </button>
            <button type="button" class="confirmOrder-info-top__btn2 margin-left_24" @click="cancelShip">
              <span>取消订单</span>
            </button>
          </div>
        </div>
        <div class="confirmOrder-info-main flex">
          <div class="confirmOrder-info-main__left">
            <div class="flex flex-column-center margin-top_16">
              <img
                src="../../../../assets/img/client/booking/dian-icon-normal.png"
                width="16px"
                height="16px"
              >
              <div class="confirmOrder-info-main__left-line" />
              <img
                src="../../../../assets/img/client/booking/dian-icon-normal.png"
                width="16px"
                height="16px"
              >
            </div>
            <div class="flex flex-column-center flex-row-between margin-top_16">
              <div class="flex-1 confirmOrder-info-main__left-text text-align-left">
                {{ data.startCityName }}｜{{ data.startCityZipcode }}
              </div>
              <div class="confirmOrder-info-main__left-center flex flex-column-center flex-row-center">
                <img
                  src="../../../../assets/img/client/booking/order1@2x.png"
                  width="16px"
                  height="16px"
                  alt="i"
                >
                <span>门到门</span>
              </div>
              <div class="flex-1 confirmOrder-info-main__left-text text-align-right">
                {{ data.destCountryName }}｜{{ data.destCityNameEn }}
              </div>
            </div>
          </div>
          <div class="confirmOrder-info-main__right margin-left_16 flex-1">
            <div class="confirmOrder-info-main__right-order" style="text-align: left">
              <el-select v-model="value" placeholder="订单状态">
                <el-option
                  v-for="item in statusList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </div>
            <div class="confirmOrder-info-main__right-text1 margin-top_8">
              {{ statusList[data.status-1] }}
            </div>
            <div class="confirmOrder-info-main__right-text2 margin-top_8">
              请填写所有运输说明，以便处理您的货件
            </div>
            <div class="state-steps">
              <div
                v-for="(index, i) in stateList"
                :key="i"
                :class="[
                  'state-steps-default',
                  state > i
                    ? state == 1
                      ? 'state-steps-active'
                      : 'state-steps-active2'
                    : '',
                ]"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="confirmOrder-tabs margin-top_16">
        <el-tabs v-model="selectNumber">
          <el-tab-pane v-if="data.status==1" label="信息完善" :name="'0'" />
          <el-tab-pane label="订单详情" :name="'1'" />
          <el-tab-pane label="费用明细" :name="'2'" />
          <el-tab-pane label="报价" :name="'3'" />
          <el-tab-pane label="轨迹" :name="'4'" />
        </el-tabs>
      </div>
      <div class="confirmOrder-main">
        <ActionIndex v-show="selectNumber == 0 && data.status == 1" ref="ActionIndex" @finish="finish" />
        <SummaryIndex v-show="selectNumber == 1" ref="SummaryIndex" />
        <ShipmentCharges v-show="selectNumber == 2" ref="ShipmentCharges" />
        <Quote v-show="selectNumber == 3" ref="Quote" />
        <TransitInfo v-show="selectNumber == 4" ref="TransitInfo" />
      </div>
    </div>
    <ChatDialog v-if="chatVisible" ref="ChatDialog" @close="closeChat" />
    <CancelShipment ref="cancelSh" @confirm="finish" />
  </div>
</template>

<script>
import { GetExpOrderDetail, UpdateRefNo, ExportOrderDetail } from '@/api/order.js'
import { ExportBillDetail } from '@/api/user.js'
import { GetChatUserId } from '@/api/user.js'
import StatusDialog from './statusDialog.vue'
import ActionIndex from './confirmOrderTab/actionRequired/actionIndex.vue'
import SummaryIndex from './confirmOrderTab/summary/summaryIndex.vue'
import TransitInfo from '@/client/home/placeAnOrder/exp/confirmOrderTab/summary/TransitInfo.vue'
import ShipmentCharges from './confirmOrderTab/shipmentCharges/shipmentCharges.vue'
import Quote from './confirmOrderTab/quote/quote.vue'
import * as define from '@/utils/define.js'
import BookingCancelled from './bookingCancelled.vue'
import ChatDialog from '@/client/home/chatBox/index.vue'
import CancelShipment from './confirmOrderTab/actionRequired/cancelShipment.vue'
export default {
  name: 'ConfirmOrder',
  components: {
    // 组件的引用
    StatusDialog,
    ActionIndex,
    SummaryIndex,
    ShipmentCharges,
    Quote,
    BookingCancelled,
    ChatDialog,
    CancelShipment,
    TransitInfo
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      stateList: 6,
      state: 1,
      orderInfoSteps: [{
        title: '信息完善',
        index: 0
      },
      {
        title: '订单详情',
        index: 1
      },
      {
        title: '费用明细',
        index: 2
      },
      {
        title: '报价',
        index: 3
      },
      {
        title: '轨迹',
        index: 4
      }
      ],
      selectNumber: '0',
      isStatusDialog: false,
      data: {},
      statusList: ['待完善', '已预报', '已收货', '已订舱',
        '已发货', '已送达', '已取消'
      ],
      isUpdateRefNo: false,
      chatVisible: false
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    downloadBill() {
      ExportBillDetail({
        orderNo: this.data.orderNo
      }).then(res => {
        if (res.code === 200) {
          this.xms.downloadFile(res.data.url)
        }
      })
    },
    downloadOrder() {
      ExportOrderDetail({
        orderNo: this.data.orderNo
      }).then(res => {
        if (res.code === 200) {
          this.xms.downloadFile(res.data.url)
        }
      })
    },
    cancelShip() {
      this.$refs.cancelSh.init(this.data)
    },
    closeChat() {
      this.chatVisible = false
    },
    clickChat(item) {
      GetChatUserId().then(res => {
        if (res.code === 200) {
          this.chatVisible = true
          this.$nextTick(() => {
            this.$refs.ChatDialog.init(null, null, res.data)
          })
        }
      })
    },
    eidtRefNo() {
      this.isUpdateRefNo = true
      this.$nextTick(() => {
        this.$refs.RefNo.focus()
      })
    },
    saveRefNo() {
      this.isUpdateRefNo = false
      UpdateRefNo({
        orderNo: this.data.orderNo,
        refNo: this.data.refNo
      }).then(res => {
        if (res.code == 200) {
          this.initOrder(this.data.orderNo)
        }
      })
    },
    finish() {
      this.initOrder(this.data.orderNo)
    },
    init(data) {
      this.data = data
      this.state = this.data.status
      if (this.state >= 8) {
        this.state = 0
      }
      this.$nextTick(() => {
        this.$refs.ActionIndex.init(data)
        this.$refs.SummaryIndex.init(data)
        this.$refs.ShipmentCharges.init(data)
        this.$refs.Quote.init(data)
        this.$refs.TransitInfo.init(data)
        this.actionShow()
      })
    },
    initOrder(orderNo, index) {
      GetExpOrderDetail(orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
          this.state = this.data.status
          if (this.state >= 7) {
            this.state = 0
          }
          if (this.data.insuranceInfo.insuranceLogo) {
            this.data.insuranceInfo.insuranceLogo = define.comUrl + this.data.insuranceInfo
              .insuranceLogo
          } else {
            this.data.insuranceInfo.insuranceLogo = undefined
          }
          this.totalAmount = this.data.totalAmount
          if (this.data.insuranceInfo.buyAmount) {
            this.totalAmount += this.data.insuranceInfo.insuranceRate
          }

          this.$refs.ActionIndex.init(this.data)
          this.$refs.SummaryIndex.init(this.data)
          this.$refs.ShipmentCharges.init(this.data)
          this.$refs.Quote.init(this.data)
          // this.$refs.StatusDialog.init(this.data)
          this.actionShow()
          if (index != undefined) {
            this.selectNumber = index + 1
          }
        }
      })
    },
    actionShow() {
      if (this.data.status === 1) {
        this.orderInfoSteps = [{
          title: '信息完善',
          index: 0
        },
        {
          title: '订单详情',
          index: 1
        },
        {
          title: '费用明细',
          index: 2
        },
        {
          title: '报价',
          index: 3
        }
        ]
        this.selectNumber = '0'
      } else {
        this.orderInfoSteps = [{
          title: '订单详情',
          index: 1
        },
        {
          title: '费用明细',
          index: 2
        },
        {
          title: '报价',
          index: 3
        }
        ]
        this.selectNumber = '1'
      }
    },
    // 方法
    clickType(item, index) {
      this.selectNumber = index
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang='scss'>
	.flex1 {
		display: flex;
		align-items: center;
	}

	.m8 {
		margin: 0 8px;
	}

	.confirmOrder-title-font {
		font-size: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 600;
		color: #333333;
	}

	.confirmOrder {
		z-index: 101;
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: auto;
		margin: 0;
		//background: rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.04);
		backdrop-filter: blur(8px);

		.confirmOrder-main {
			margin: 0 auto;
			width: 1200px;

			.confirmOrder-title {
				@extend .flex1;
				justify-content: space-between;
				margin: 24px 0;

				.confirmOrder-title-l {
					@extend .flex1;

					span:nth-of-type(1) {
						color: #E95506;
						margin-right: 12px;
					}

					span:nth-of-type(2) {
						@extend .confirmOrder-title-font;
					}
				}

				.confirmOrder-title-r {
					cursor: pointer;
					@extend .confirmOrder-title-font;

					span {
						margin-left: 10px;
						font-weight: bold;

					}
				}

			}

			.confirmOrder-tab {
				width: 1200px;
				height: 192px;
				background: #FFFFFF;
				border-radius: 8px;
				border: 1px solid rgba(170, 170, 170, 0.16);

				.order-information {
					height: 136px;
					display: flex;

					.order-info-l {
						width: 368px;
						height: 112px;
						border-right: 1px solid #DDDDDD;
						margin: 16px 24px 8px 16px;
						text-align: left;

						div:nth-of-type(1) {
							height: 40px;
							//line-height: 40px;
							padding: 10px 8px;
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #333333;
						}

						div:nth-of-type(2) {
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #777777;
							margin-left: 8px;
						}
					}

					.order-info-3 {
						width: 368px;
						height: 112px;
						border-left: 1px solid #DDDDDD;
						margin: 16px 24px 8px 16px;
						text-align: left;
						padding-left: 15px;

						div:nth-of-type(1) {
							height: 40px;
							padding: 10px 8px;
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #333333;
						}

						div:nth-of-type(2) {
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #777777;
							margin-left: 8px;
						}
					}

					.order-info-r {
						text-align: left;
						margin: 26px 0 0 8px;

						.r-one {
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #333333;
						}

						.r-two {
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							color: #EF0A0A;
							margin: 10px 0 5px 0;
						}

						.r-two2 {
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							color: #1DB62F;
							margin: 10px 0 5px 0;
						}

						.r-three {
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #777777;
						}

						.state-steps {
							display: flex;
							margin-top: 9px;

							.state-steps-default {
								width: 56px;
								height: 8px;
								//background: #EF0A0A;
								background: rgba(170, 170, 170, 0.24);
								//border-radius: 4px 0px 0px 4px;
								margin-right: 2px;
							}

							.state-steps-default:first-child {
								border-radius: 4px 0px 0px 4px;
							}

							.state-steps-default:last-child {
								border-radius: 0px 4px 4px 0px;
							}

							.state-steps-active {
								background: #EF0A0A;
							}

							.state-steps-active2 {
								background: #1DB62F;
							}
						}
					}
				}

				.order-info-steps {
					height: 56px;
					border-top: 1px solid rgba(221, 221, 221, 0.56);
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-left: 16px;

					.tab-class {
						cursor: pointer;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						margin-right: 24px;
					}

					.active {
						// width: 133px;
						// height: 32px;
						background: rgba(233, 85, 6, 0.08);
						border-radius: 8px;
						line-height: 32px;
						text-align: center;
						color: #E95506;
						padding: 0px 8px;
					}

					.order-info-steps-l {
						display: flex;
						align-items: center;
					}

					.order-info-steps-r {
						display: flex;
						align-items: center;

						.m24 {
							margin: 0 24px;
						}

						.flex1 {
							display: flex;
							align-items: center;
						}

						img {
							margin-right: 4px;
						}

						span {
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 14px;
							color: #027FFC;
							cursor: pointer;
						}
					}
				}
			}

		}

		.confirmOrder-container {
			margin: 0 auto;
			width: 1200px;

			.confirmOrder-header {
				.confirmOrder-header-title {
					font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
					font-weight: bold;
					font-size: 20px;
					color: #333333;
					line-height: 27px;
					text-align: left;
					font-style: normal;
				}

				.confirmOrder-header-text {
					margin-top: 8px;
					font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
					font-weight: 400;
					font-size: 12px;
					color: #777777;
					line-height: 17px;
					text-align: left;
					font-style: normal;
				}

				.close-btn {
					outline: none;
					border: none;
					width: 78px;
					height: 32px;
					background: rgba(0, 0, 0, 0.08);
					border-radius: 8px;

					span {
						display: inline-block;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 14px;
						color: #333333;
						line-height: 20px;
						text-align: right;
						font-style: normal;
					}

					i {
						font-size: 14px;
						font-weight: bold;
						color: #333;
					}

					&:hover {
						cursor: pointer;
					}
				}
			}

			.confirmOrder-info {
				width: 100%;
				padding-bottom: 8px;
				background: #ffffff;
				border-radius: 8px;
				box-sizing: border-box;

				.confirmOrder-info-top {
					padding: 0 24px;
					height: 64px;
					background: #f5f7fa;
					border-radius: 8px 8px 0px 0px;
					border: 2px solid #ffffff;
					box-sizing: border-box;

					.confirmOrder-info-top__text1 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.confirmOrder-info-top__text2 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.confirmOrder-info-top__btn1 {
						outline: none;
						border: none;
						width: 88px;
						height: 32px;
						background: rgba(51, 112, 255, 0.04);
						border-radius: 8px;
						border: 1px solid rgba(51, 112, 255, 0.24);

						box-sizing: border-box;

						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 13px;
							color: #3370ff;
							line-height: 18px;
							text-align: left;
							font-style: normal;
						}

						&:hover {
							cursor: pointer;
						}
					}

					.confirmOrder-info-top__btn2 {
						outline: none;
						border: none;
						width: 72px;
						height: 32px;
						background: rgba(2, 127, 252, 0);
						border-radius: 8px;

						box-sizing: border-box;

						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 13px;
							color: #777777;
							line-height: 18px;
							text-align: left;
							font-style: normal;
						}

						&:hover {
							cursor: pointer;
						}
					}
				}

				.confirmOrder-info-main {
					margin: 8px 8px 0 8px;

					box-sizing: border-box;

					.confirmOrder-info-main__left {
						padding: 16px 24px;
						width: 752px;
						min-height: 112px;
						background: rgba(245, 247, 250, 0.56);
						border-radius: 6px;
						box-sizing: border-box;

						.confirmOrder-info-main__left-line {
							flex: 1;
							height: 1px;
							border-top: 2px dashed #aaaaaa;
						}

						.confirmOrder-info-main__left-text {
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 14px;
							color: #333333;
							line-height: 20px;
							font-style: normal;
						}

						.confirmOrder-info-main__left-center {
							margin: 0 40px;
							width: 80px;
							height: 32px;
							background: rgba(51, 112, 255, 0.08);
							border-radius: 9px;

							span {
								display: inline-block;
								font-family: PingFangSC, PingFang SC;
								font-weight: 600;
								font-size: 13px;
								color: #3370ff;
								line-height: 18px;
								text-align: left;
								font-style: normal;
							}
						}
					}

					.confirmOrder-info-main__right {
						.confirmOrder-info-main__right-order ::v-deep .el-select {
							width: 100px;
							height: 32px;

							.el-input__inner {
								border: none;
								padding: 0 8px;
								line-height: 32px;
								height: 32px;

								&::-webkit-input-placeholder {
									font-family: PingFangSC, PingFang SC;
									font-weight: 500;
									font-size: 14px;
									color: #333333;
									text-align: left;
									font-style: normal;
								}
							}

							.el-input__icon {
								line-height: 32px;
								color: #000000;
							}
						}

						.confirmOrder-info-main__right-text1 {
							padding: 0 8px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 14px;
							color: #ef0a0a;
							line-height: 20px;
							text-align: left;
							font-style: normal;
						}

						.confirmOrder-info-main__right-text2 {
							padding: 0 8px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 13px;
							color: #777777;
							line-height: 18px;
							text-align: left;
							font-style: normal;
						}

						.state-steps {
							display: flex;
							margin: 8px;

							.state-steps-default {
								width: 56px;
								height: 8px;
								background: rgba(170, 170, 170, 0.24);
								margin-right: 2px;
							}

							.state-steps-default:first-child {
								border-radius: 4px 0px 0px 4px;
							}

							.state-steps-default:last-child {
								border-radius: 0px 4px 4px 0px;
							}

							.state-steps-active {
								background: #ef0a0a;
							}

							.state-steps-active2 {
								background: #1db62f;
							}
						}
					}
				}
			}

			.confirmOrder-tabs {
				padding: 0 4px;
				height: 56px;
				background: #ffffff;
				border-radius: 8px;

				& ::v-deep .el-tabs {
					.el-tabs__header {
						margin: 0;
					}

					.el-tabs__nav-wrap::after {
						background-color: transparent;
					}

					.el-tabs__item {
						padding: 18px 16px;
						height: 56px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: center;
						font-style: normal;
						box-sizing: border-box;
					}

					.el-tabs__item.is-active {
						font-family: PingFangSC, PingFang SC;
						font-weight: 550;
						font-size: 13px;
						color: #3370ff;
						line-height: 18px;
						text-align: center;
						font-style: normal;
					}

					.el-tabs__active-bar {
						background-color: #3370ff;
					}
				}
			}

			.confirmOrder-main {}
		}
	}
</style>
